import { generateUuid } from '@3dsource/utils';
import type { User } from '@graphql/legacy/types';

export const mapUserAvatarPath = (me: User): User => ({
  ...me,
  avatarPath: `${me.avatarPath}?uniqueId=${generateUuid()}`,
});
